var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, toRef, watch } from "vue";
import { useJobStore } from "@/stores/jobStore";
import { useMappingJobs } from "./handlesMappingJobs";
import JobSelection from "./JobSelection.vue";
import JobParameters from "@/components/JobParameters/JobParameters.vue";
import ToolLinkPopover from "@/components/Tool/ToolLinkPopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JobParameters',
    props: {
        jobId: { default: undefined },
        implicitCollectionJobsId: { default: undefined },
        param: { default: undefined },
        title: { default: undefined },
        footer: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const jobStore = useJobStore();
        const toolId = computed(() => {
            var _a;
            if (targetJobId.value) {
                return (_a = jobStore.getJob(targetJobId.value)) === null || _a === void 0 ? void 0 : _a.tool_id;
            }
            return undefined;
        });
        const toolVersion = computed(() => {
            var _a;
            if (targetJobId.value) {
                return (_a = jobStore.getJob(targetJobId.value)) === null || _a === void 0 ? void 0 : _a.tool_version;
            }
            return undefined;
        });
        const jobIdRef = toRef(props, "jobId");
        const implicitCollectionJobsIdRef = toRef(props, "implicitCollectionJobsId");
        const { selectJobOptions, selectedJob, targetJobId } = useMappingJobs(jobIdRef, implicitCollectionJobsIdRef);
        function init() {
            return __awaiter(this, void 0, void 0, function* () {
                if (targetJobId.value) {
                    jobStore.fetchJob(targetJobId.value);
                }
            });
        }
        watch(targetJobId, () => {
            init();
        }, { immediate: true });
        return { __sfc: true, props, jobStore, toolId, toolVersion, jobIdRef, implicitCollectionJobsIdRef, selectJobOptions, selectedJob, targetJobId, init, JobSelection, JobParameters, ToolLinkPopover };
    }
});
